<template>
	<div class="sms">
		<el-table :data="list">
			<el-table-column label="编号" prop="id" min-width="60"
				></el-table-column>
		
			<el-table-column label="手机号" prop="mobile" min-width="140"></el-table-column>
			<el-table-column label="内容" prop="content" min-width="200"></el-table-column>
			<el-table-column label="类型" prop="sent_type" min-width="90"></el-table-column>
			<el-table-column label="发送时间" prop="created_at" min-width="140"></el-table-column>
			
		</el-table>
		<el-pagination @current-change="pageChange" :current-page.sync="pager.page" hide-on-single-page
			:page-size="pager.pagesize" 
				prev-text="上一页"
				next-text="下一页"
				layout="total, prev, pager, next,jumper" :total="Number(pager.count)">
		</el-pagination>
	</div>
</template>

<script>
	
	import {
		getSmsList
	} from "@/utils/axios"
	
	
	import {Base64} from 'js-base64'
	
	
	export default {
		name:"adminSms",
		data(){
			return {
				list:[],
				pager: {
					page: 1,
					pagesize: 12,
					count: 0
				},
			}
		},
		created(){
			this.getList()
		},
		methods:{
			getList(){
				getSmsList(this.pager).then(res => {
					if(res.code === 200){
						const result = JSON.parse(Base64.decode(res.data))
						console.log("result",result);
						this.list = result.data 
						this.pager = result.pager
					}else{
						this.list = []
					}
				})
			},
			pageChange(page) {
				this.pager.page = page;
				this.getList();
			},
		}
	}
	
	
</script>

<style scoped>
</style>

<style lang="scss" scoped>
	.sms{
		position: relative;
		width: 100%;
		padding: 24px;
	}
</style>